// packages/web/src/components/layout/MobileBottomNav.tsx
import { Link, useLocation, useNavigate } from 'react-router';
import { MessageSquare, Workflow, Menu } from 'lucide-react';
import { activeMobileTab } from '@/lib/mobile-nav';
import { cn } from '@/lib/utils';

interface MobileBottomNavProps {
  /** Open the conversation drawer (only has an effect on the chat route). */
  onOpenMenu: () => void;
}

export function MobileBottomNav({ onOpenMenu }: MobileBottomNavProps): React.ReactElement {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const active = activeMobileTab(pathname);

  const handleMenu = (): void => {
    if (pathname === '/chat' || pathname.startsWith('/chat/')) {
      onOpenMenu();
    } else {
      void navigate('/chat');
    }
  };

  const itemClass = (isActive: boolean): string =>
    cn(
      'flex flex-1 flex-col items-center justify-center gap-0.5 py-2 text-[11px] font-medium transition-colors',
      isActive ? 'text-primary' : 'text-text-secondary'
    );

  return (
    <nav className="flex border-t border-border bg-surface pb-safe md:hidden">
      <Link to="/chat" className={itemClass(active === 'chat')}>
        <MessageSquare className="h-5 w-5" />
        Chat
      </Link>
      <Link to="/workflows" className={itemClass(active === 'workflows')}>
        <Workflow className="h-5 w-5" />
        Workflows
      </Link>
      <button type="button" onClick={handleMenu} className={itemClass(false)}>
        <Menu className="h-5 w-5" />
        Menu
      </button>
    </nav>
  );
}
